import styled from 'foundations-theming-specialty/utils';
import TrackedButton from '../../TrackedButton';
import HappyIcon from '../../icons/Happy';
import NeutralIcon from '../../icons/Neutral';
import UnhappyIcon from '../../icons/Unhappy';
import { FeedbackRating } from '../../../hooks/useFeedbackReducer/constants';
import { useTranslation } from '../../../hooks/useNavConfig';
import { jsx as _jsx } from "react/jsx-runtime";
const FEEDBACK_ICON_SIZE = '64px';
const ratingData = {
  [FeedbackRating.HAPPY]: {
    color: 'do-not-use-chart-green',
    title: 'nav.feedbackModal.rating.happy'
  },
  [FeedbackRating.NEUTRAL]: {
    color: 'do-not-use-sorbet-medium',
    title: 'nav.feedbackModal.rating.neutral'
  },
  [FeedbackRating.UNHAPPY]: {
    color: 'do-not-use-norman-medium',
    title: 'nav.feedbackModal.rating.unhappy'
  }
};
const StyledButton = styled(TrackedButton)(({
  theme,
  $type
}) => {
  const color = theme.color[ratingData[$type].color];
  return {
    margin: '0 4px',
    padding: '4px',
    background: 'none',
    borderRadius: '50%',
    border: '6px solid transparent',
    lineHeight: 0,
    transition: 'border-color 0.2s linear 0s',
    '&:hover': {
      border: `6px solid ${color}`
    },
    svg: {
      width: FEEDBACK_ICON_SIZE,
      height: FEEDBACK_ICON_SIZE
    }
  };
});
const RatingsIcon = ({
  type
}) => {
  const {
    t
  } = useTranslation();
  const title = ratingData[type].title;
  switch (type) {
    case FeedbackRating.HAPPY:
      return /*#__PURE__*/_jsx(HappyIcon, {
        title: t(title)
      });
    case FeedbackRating.NEUTRAL:
      return /*#__PURE__*/_jsx(NeutralIcon, {
        title: t(title)
      });
    case FeedbackRating.UNHAPPY:
      return /*#__PURE__*/_jsx(UnhappyIcon, {
        title: t(title)
      });
    default:
      return null;
  }
};
const RatingsButton = ({
  onClick,
  type
}) => {
  return /*#__PURE__*/_jsx(StyledButton, {
    onClick: onClick,
    $type: type,
    children: /*#__PURE__*/_jsx(RatingsIcon, {
      type: type
    })
  });
};
export default RatingsButton;